import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export const Breadcrumbs = ({ items }) => (
  <nav aria-label="Breadcrumb" className="flex flex-wrap items-center gap-1.5 text-xs font-semibold text-[#2E1B16]/45" data-testid="breadcrumbs">
    {items.map((it, i) => {
      const last = i === items.length - 1;
      return (
        <span key={it.to} className="inline-flex items-center gap-1.5">
          {i > 0 && <ChevronRight size={12} aria-hidden="true" />}
          {last ? <span aria-current="page" className="text-[#2E1B16]/70">{it.name}</span> : <Link to={it.to} className="hover:text-[#38BDF8] transition-colors">{it.name}</Link>}
        </span>
      );
    })}
  </nav>
);

export default Breadcrumbs;
